<template>
  <div>
    <top-header-info></top-header-info>
    <top-logo state="0"></top-logo>
    <div class="page-login">
      <div class="login-wrap">
        <div class="right-user-wrap">
          <div class="title">
            <h2>修改密码</h2>
          </div>
          <ul class="info-body">
            <li>
              <span>账号邮箱</span>
              <el-input
                placeholder="请输入账号邮箱"
                v-model="form.username"
              ></el-input>
              <div class="text">使用邮箱登录的用户可自助修改登录密码</div>
            </li>
            <li>
              <span>验证码</span>
              <el-input
                placeholder="请输入验证码"
                v-model="form.token"
              ></el-input>
              <div class="text yzm" @click="getYzm">
                {{ yzmTime === 0 ? "获取验证码" : this.yzmTime + "s后获取" }}
              </div>
            </li>
            <li>
              <span>新密码</span>
              <el-input
                placeholder="请输入新密码"
                v-model="form.new_password"
                show-password
              ></el-input>
              <div class="text">
                请输入6-20位数字、字母（区分大小写）或符号（除空格）且数字、字母和符号至少包含两种
              </div>
            </li>
            <li>
              <span>新密码</span>
              <el-input
                placeholder="请再次输入新密码"
                v-model="newpassword2"
                show-password
              ></el-input>
            </li>
            <li>
              <span></span>
              <el-button style="width: 95px" @click="back">取消</el-button>
              <el-button
                @click="forget"
                style="width: 95px"
                :type="oButton ? 'danger' : 'info'"
                >更改密码</el-button
              >
            </li>
          </ul>
        </div>

        <div class="rest-f-tail">
          <div class="footer">
            <div class="rest-f-legal-link">
              <router-link :to="{ name: 'index' }">首页</router-link>
              <router-link :to="{}">关于我们</router-link>
              <router-link :to="{}">联系我们</router-link>
              <router-link :to="{}">企业申请</router-link>
              <router-link :to="{}">用户协议</router-link>
              <!-- <router-link :to="{}">诚聘英才</router-link> -->
              <span>客服电话:400-088-8635</span>
            </div>
            <div class="rest-f-legal-ba">
              <a href="http://www.miibeian.gov.cn" target="_blank"
                >备案/许可证号：沪ICP备17048375号-1</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopHeaderInfo from "@/components/top-header-info";
import TopLogo from "@/components/top-logo";
import LOADINGIMG from "@/assets/images/loading.gif";
export default {
  components: {
    TopHeaderInfo,
    TopLogo
  },
  data() {
    return {
      newpassword2: "",
      form: { username: "", token: "", new_password: "", type: "email" },
      yzmTime: 0,
      validation: "",
      method: 1,
      user: { mobile: "", sms_code: "" },
      codeUrl: LOADINGIMG
    };
  },
  mounted() {},
  computed: {
    oButton() {
      if (
        this.form.username &&
        this.form.token &&
        this.form.new_password &&
        this.newpassword2
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    open(mes) {
      this.$message({
        message: mes,
        type: "warning"
      });
    },
    getCode() {
      this.$reqGet("api/store/login/qrcode").then(res => {
        this.codeUrl = res.data.data.url;
        this.checkLogin(res.data.data.code);
      });
    },
    getYzm() {
      if (this.yzmTime !== 0) {
        return;
      }
      if (!this.form.username) {
        this.open("请先输入邮箱");
      }
      this.$reqPost(
        "api/store/send_edit_password_mail?access_token=" + this.form.username,
        {
          email: this.form.username
        }
      ).then(res => {
        if (res.data.success) {
          this.yzmTime = 60;
          let clock = setInterval(() => {
            if (this.yzmTime > 0) {
              this.yzmTime--;
            } else {
              clearInterval(clock);
            }
          }, 1000);
          this.$message({
            message: "发送成功",
            type: "success"
          });
        }
      });
    },
    forget() {
      if (!this.form.username) {
        this.open("请输入邮箱账号");
        return;
      }
      if (
        !this.form.username.match(
          "^[a-z0-9A-Z]+[- | a-z0-9A-Z . _]+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-z]{2,}$"
        )
      ) {
        this.open("邮箱验证码错误");
        return;
      }

      if (!this.form.token) {
        this.open("请输入验证码");
        return;
      }
      if (!this.form) {
        this.open("请输入新密码");
        return;
      }
      if (!this.newpassword2) {
        this.open("请输入新密码");
        return;
      }
      if (this.newpassword2 !== this.form.new_password) {
        this.open("两次输入的新密码不一致");
        return;
      }
      var reg = /\s/;
      if (
        !this.form.new_password.match(
          "^(((?=.*[0-9])(?=.*[a-zA-Z])|(?=.*[0-9])(?=.*[^0-9a-zA-Z])|(?=.*[a-zA-Z])(?=.*[^0-9a-zA-Z]))[^]{6,20})$"
        ) ||
        reg.test(this.form.new_password)
      ) {
        this.open("新密码格式错误");
        return;
      }
      this.$confirm("确认修改密码吗？", { type: "warning" })
        .then(() => {
          this.$reqPost(
            "api/usercenter/changePasswordByCode?access_token=" +
              this.form.username,
            this.form
          ).then(res => {
            if (res.data.success) {
              this.$message({
                message: "密码修改成功！",
                type: "success"
              });
              this.form = {};
              this.newpassword2 = "";
              setTimeout(() => {
                this.$router.back();
              }, 500);
            }
          });
        })
        .catch(() => {});
    },
    back() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="less" scoped>
.page-login {
  position: relative;
  margin-bottom: 20px;
}
.page-login .account_zhezhao_wrapper {
  position: fixed;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.page-login .login-wrap {
  height: 600px;
  background-color: #fff;
}
.right-user-wrap {
  // position: relative;
  min-height: 470px;
  width: 700px;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 10px 25px 0;
  .title {
    line-height: 42px;
    height: 42px;
    border-bottom: 2px solid #dadada;
    margin-bottom: 30px;
    h2 {
      display: inline-block;
      border-bottom: 2px solid #e2333f;
      font-size: 20px;
      font-weight: normal;
      margin: 0;
      box-sizing: border-box;
      padding: 0 20px;
    }
  }
  .info-body {
    li {
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      span {
        display: block;
        width: 60px;
        text-align-last: justify;
        margin-right: 40px;
      }
      .el-input {
        width: 200px;
      }
      .text {
        margin-left: 20px;
        width: 300px;
      }
      .yzm {
        color: #fc0010;
        cursor: pointer;
      }
    }
  }
}

.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .rest-checkbox-wrap {
  display: block;
  font-size: 16px;
  color: #999999;
  margin-top: 15px;
  text-align: center;
  padding: 10px 40px;
  line-height: 32px;
  img {
    width: 45px;
  }
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .rest-checkbox-wrap
  .forget-password {
  padding-top: 10px;
  float: left;
  font-size: 14px;
  cursor: pointer;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .rest-checkbox-wrap
  .login_accont_info {
  padding-top: 10px;
  float: right;
  font-size: 14px;
  cursor: pointer;
}
.page-login
  .login-wrap
  .login-inner
  .login-form
  .login-box
  .mc
  .form
  .rest-form
  .login-main
  .btn-wrap
  .login-btn {
  text-align: center;
  cursor: pointer;
  border: 0;
  background: #ff4400;
  color: #fff;
  font-size: 18px;
  width: 90%;
  margin-left: 5%;
  margin-top: 20px;
  height: 42px;
  border-radius: 21px;
  outline: 0;
}
.page-login .login-wrap .login-banner {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 600px;
  background: url(../../assets/images/logo_bg.png) no-repeat;
  background-position: center;
  background-size: cover;
}
.page-login .login-wrap .login-banner .banner {
  margin: 0 auto;
}
.page-login .login-wrap .login-banner .banner .banner-bg {
  position: relative;
  z-index: 3;
  height: 600px;
}
.code-wrap {
  position: relative;
  text-align: center;
  .code {
    margin-top: 10px;
    width: 150px;
    height: 150px;
  }
  .refresh-wrap {
    position: absolute;
    top: 10px;
    left: 80px;
    width: 150px;
    height: 150px;
    background-color: rgba(0, 1, 1, 0.6);
    color: #eee;
    cursor: pointer;
    i {
      font-size: 24px;
      color: #fff;
      margin-top: 40px;
    }
  }
}

.saoma {
  margin-top: 15px;
  line-height: 22px;
  color: #999;
  .el-col:first-child {
    text-align: right;
    padding-right: 10px;
    img {
      width: 30px;
      height: 30px;
      margin-top: 6px;
    }
  }

  .orange {
    color: #fc5e26;
  }
}
.rest-f-tail {
  padding: 40px;
  background-color: #fff;
  text-align: center;
  a,
  span {
    color: #494949;
    min-width: 100px;
    border-right: 1px solid #ddd;
    line-height: 26px;
  }
  .rest-f-legal-link {
    span:last-child {
      border: none;
    }
  }
  a:last-child {
    border: none;
  }
  a:hover {
    color: #55c3fd;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/forget.vue